defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/ViewCoupon',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/ViewPlayCoupon',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardFlowHeader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubPage'
  ],
  function (Component, PlayTogetherDictionary, ViewPlayCoupon, CardFlowHeader, ClubPage) {

    // Component:
    Component('view-coupon', [PlayTogetherDictionary], function (m, route, settings, property) {

      // Components:
      var root = {
        controller: function () {
          this.property = property;
          this.settings = settings;
          this.rootDictionary = PlayTogetherDictionary;
          this.clubPageClassName = m.prop('play-together-play-coupon-page');
        },

        view: function (controller) {
          return m(ClubPage, { controller: controller }, {
            flowHeader: CardFlowHeader({
              goBack: function () {
                window.history.back();
              }
            }),
            content: ViewPlayCoupon
          });
        }
      };

      // Routes:
      route('/', root);
    });

  });
